import { useState } from 'react';

import { copyIcon } from '@marketplace/ui-elements';
import classes from '../../app-list.module.scss';

type TIdCellProps = {
  id: string | null;
};

export const IdCell = ({ id }: TIdCellProps) => {
  const copyTextToClipboard = (e: React.MouseEvent<HTMLElement>): void => {
    e.preventDefault();
    navigator.clipboard.writeText(id || '');
    e.stopPropagation();
  };

  if (!id) return null;

  return (
    <>
      <span>{id}</span>
      <div className={classes.img_wrapper}>
        <img
          src={copyIcon}
          alt=""
          className={classes.icon}
          onClick={copyTextToClipboard}
        />
      </div>
    </>
  );
};
